import React, { useState } from 'react';
import clsx from 'clsx';
import { TextField } from '@/components/inspector-fields/TextField/TextField';
import IconSearch from '@/assets/icons/icon-search.svg?react';

interface PanelTopSearchProps {
  text: string;
  className: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch?: (value: string) => void;
  placeholder: string;
  padded?: boolean;
  containerClassName?: string;
  inputClassName?: string;
  'data-qa-selector'?: string;
}

export const PanelTopSearch: React.FC<PanelTopSearchProps> = ({
  className,
  onChange,
  onSearch,
  placeholder = 'Search ...',
  padded = true,
  containerClassName,
  inputClassName,
  'data-qa-selector': dataQaSelector,
}) => {
  const [value, setValue] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    if (onChange) onChange(e);
  };

  const handleSearch = () => {
    if (onSearch) onSearch(value);
  };

  return (
    <div
      className={clsx(
        'inline-flex w-full flex-col items-center justify-center gap-4 self-stretch',
        padded ? 'p-6' : 'p-0',
        className,
      )}
    >
      <div className={clsx('relative flex w-full items-center', containerClassName)}>
        <TextField
          className="w-full"
          classNameInput={clsx('p-2', inputClassName)}
          classNameInputParent="max-w-full w-full"
          icon={IconSearch}
          inputValue={value}
          placeholderText={placeholder}
          state="default"
          text=""
          type="text"
          onChange={handleChange}
          onIconClick={handleSearch}
          data-qa-selector={dataQaSelector}
        />
      </div>
    </div>
  );
};
